angular.module('app').config(resourcesRouting);

function resourcesRouting($routeProvider) {
  $routeProvider.when('/resources', {
    pageTitle: 'RESOURCES',
    template: '<resources-page></resources-page>',
    breadcrumb: {
      label: 'COMPANY_SETTINGS',
      parent: 'bg/company_settings',
    },
    menu: 'settings',
    accessPermission: 'index_resource_accountadmin',
    authReq: true,
  });
}

resourcesRouting.$inject = ['$routeProvider'];
